import { useState, useEffect } from 'react';
import api from '@/lib/api';
import './accountingReports.css';

export function useTenantCompanyName() {
  const [name, setName] = useState('');
  useEffect(() => {
    api
      .get('/tenant/dashboard')
      .then((r) => {
        const t = r.data?.tenant;
        setName(t?.name || (t?.subdomain ? `${t.subdomain}.tokomoe.com` : '') || '');
      })
      .catch(() => setName(''));
  }, []);
  return name;
}

export function ReportToolbar({ children }) {
  return <div className="acct-rpt-toolbar no-print">{children}</div>;
}

/**
 * @param {string} companyName
 * @param {string} title — e.g. Laporan Laba Rugi
 * @param {string} [subtitle]
 * @param {string} [periodLabel] — e.g. Untuk periode 1 Jan – 31 Mar 2025
 */
export function ReportDocument({ companyName, title, subtitle, periodLabel, children }) {
  return (
    <div className="acct-rpt-doc">
      <header className="acct-rpt-header">
        <p className="acct-rpt-company">{companyName || 'Nama usaha'}</p>
        <h2 className="acct-rpt-title">{title}</h2>
        {subtitle ? <p className="acct-rpt-subtitle">{subtitle}</p> : null}
        {periodLabel ? <p className="acct-rpt-period">{periodLabel}</p> : null}
        <p className="acct-rpt-footnote">Disajikan dalam Rupiah</p>
      </header>
      <div className="acct-rpt-content">{children}</div>
    </div>
  );
}

export function fmtRp(v) {
  const n = Number(v) || 0;
  return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n);
}
